import React, { Fragment, useContext, useState } from "react";
import styles from './thirdPartyQuestionsToAsk.module.css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Box } from "@mui/material";
import {
    ICategoriesTree, IQuestionsFromSubCategories, ISubCategories,
} from "../../../Models/thirdPartyQuestionnarieModels";
import {
    IThirdPartyQuestionnaireContext, ThirdPartyQuestionnaireContext,
} from "../../../Context/thirdPartyQuestionnaireContext";
import { EmailComponent, IpAddressComponent, PhoneComponent, StringValueComponent } from "./allQuestionComponents";
import ThirdPartyQuestionnaireSubmit from "../thirdPartyQuestionnaireSubmit/thirdPartyQuestionnaireSubmit";

interface IThirdPartyQuestionsToAsk {
    sections: ICategoriesTree[];
}

const ThirdPartyQuestionsToAsk = (props: IThirdPartyQuestionsToAsk) => {
    return (
        <div className={styles.questions_to_ask_outer}>
            {
                props.sections.sort((a, b) => a.sequenceNo - b.sequenceNo).map((value, index) => {
                    return (
                        <RenderSectionsInThirdPartyQuestionsToAsk value={value} key={index} />
                    )
                })
            }
            <ThirdPartyQuestionnaireSubmit />
        </div>
    )
};

interface IRenderSectionsInThirdPartyQuestionsToAsk {
    value: ICategoriesTree;
}

const RenderSectionsInThirdPartyQuestionsToAsk = (props: IRenderSectionsInThirdPartyQuestionsToAsk) => {
    const [flagOpen, setFlagOpen] = useState(true);

    const UpdateFlagOpen = () => {
        setFlagOpen(!flagOpen);
    }

    return (
        <Fragment>
            <Box onClick={UpdateFlagOpen} className={styles.section_outer}>
                {
                    flagOpen ?
                        <ArrowDropDownIcon onClick={UpdateFlagOpen} /> :
                        <ArrowRightIcon onClick={UpdateFlagOpen}  />
                }
                <h1 onClick={UpdateFlagOpen} className={styles.section_title} id={props.value.categoryId}>{props.value.categoryName}</h1>
            </Box>
            {
                flagOpen &&
                <Fragment>
                    <hr className={styles.section_divider} />
                    {
                        props.value.subCategories.sort((a, b) => a.sequenceNo - b.sequenceNo).map((subSection, index) => {
                            return (
                                <RenderSubSectionsInThirdPartyQuestionsToAsk section={props.value} subSection={subSection} key={index} />
                            )
                        })
                    }
                </Fragment>
            }
        </Fragment>
    )
}

interface IRenderSubSectionsInThirdPartyQuestionsToAsk {
    subSection: ISubCategories;
    section: ICategoriesTree;
}

const RenderSubSectionsInThirdPartyQuestionsToAsk = (props: IRenderSubSectionsInThirdPartyQuestionsToAsk) => {
    return (
        <Fragment>
            <div className={styles.sub_section_outer}>
                <div className={styles.sub_section_title} id={props.subSection.subCategoryId}>
                    <span className={styles.sub_section}>{props.subSection.subCategoryName}</span>
                </div>
                {
                    props.subSection.questions.sort((a, b) => a.sequenceNo - b.sequenceNo).map((q, qI) => {
                        return (
                            <div className={styles.question} key={qI}>
                                <label id={q.questionId}>{q.questionTitle}{q.isRequired && <span style={{ color: "red" }}> *</span>}</label>
                                <InputComponentToRender section={props.section} subSection={props.subSection} question={q} />
                            </div>
                        )
                    })
                }
            </div>
        </Fragment>
    )
}

interface IInputComponentToRender {
    question: IQuestionsFromSubCategories;
    section: ICategoriesTree;
    subSection: ISubCategories;
}

const InputComponentToRender = (props: IInputComponentToRender) => {
    const { setQuestionsToAsk } = useContext(ThirdPartyQuestionnaireContext) as IThirdPartyQuestionnaireContext;

    const GetQuestionsToReturn = (subSection: ISubCategories, ans: any) => {
        return subSection.questions.map((question) => {
            if (question.questionId === props.question.questionId) {
                question.answer = ans;
                return question;
            }
            return question;
        })
    };

    const GetSubSectionsToReturn = (section: ICategoriesTree, ans: any) => {
        return section.subCategories.map((subSection) => {
            if (subSection.subCategoryId === props.subSection.subCategoryId) {
                const questionsToReturn = GetQuestionsToReturn(subSection, ans);
                return {
                    ...subSection,
                    questions: questionsToReturn
                };
            }
            return subSection;
        });
    };

    const UpdateAnswer = (ans: any) => {
        setQuestionsToAsk((prevState) => {
            return prevState.map((section) => {
                if (section.categoryId === props.section.categoryId) {
                    return {
                        ...section,
                        subCategories: GetSubSectionsToReturn(section, ans)
                    }
                }
                return section;
            });
        })
    }

    switch (props.question.questionTypeId) {
        case 1: return (
            <StringValueComponent UpdateAnswer={UpdateAnswer} {...props} />
        )
        case 2:
        case 5: return (
            <IpAddressComponent UpdateAnswer={UpdateAnswer} {...props} />
        )
        case 3: return (
            <EmailComponent UpdateAnswer={UpdateAnswer} {...props} />
        )
        case 4: return (
            <PhoneComponent UpdateAnswer={UpdateAnswer} {...props} />
        )
        default: return null;
    }
}

export default ThirdPartyQuestionsToAsk;